import React, { useId } from 'react';
import clsx from 'clsx';
import BlueGreenSquare from '../Form/VacStateSvg/BlueGreenSquare';
import GreenSquare from '../Form/VacStateSvg/GreenSquare';
import BlueSquare from '../Form/VacStateSvg/BlueSquare';
import OrangeSquare from '../Form/VacStateSvg/OrangeSquare';
import GreenTriangle from '../Form/VacStateSvg/GreenTriangle';
import { Tooltip } from 'react-tooltip';
import BlueCross from '../Form/VacStateSvg/BlueCross';
import OrangeCircle from '../Form/VacStateSvg/OrangeCircle';
export default function VacancyStatus({ type = 'accepted_by_employer' }) {
  const id = useId();
  const vacancyTypes = {
    // reset_by_staff: {
    //   text: 'Вакансия создана Менеджером/Администратором, отредактирована контрагентом',
    //   element: <BlueCross />,
    // },
    created_by_staff_edited_by_employer: {
      text: 'Вакансия создана Менеджером/Администратором, отредактирована контрагентом',
      element: <OrangeCircle />,
    },
    created_by_employer: {
      text: 'Вакансия создана Контрагентом, на модерации',
      element: <OrangeSquare />,
    },
    created_by_staff: {
      text: 'Вакансия создана Менеджером/Администратором',
      element: <GreenTriangle />,
    },
    edited_by_employer: {
      text: 'Вакансия отредактирована Контрагентом',
      element: <BlueGreenSquare />,
    },
    edited_by_staff: {
      text: 'Вакансия отредактирована Менеджером/Администратором',
      element: <GreenSquare />,
    },
    sent_to_employer: {
      text: 'Вакансия была отредактирована Администратором/Менеджером и отправлена на ознакомление Контрагенту',
      element: <GreenSquare />,
    },
    accepted_by_employer: {
      text: 'Изменения приняты Контрагентом',
      element: <BlueSquare />,
    },
    // created_by_staff: {
    //   text: 'Вакансия создана Менеджером/Администратором',
    //   element: <GreenCircle />,
    // },
    // accepted_by_employer: {
    //   text: 'Изменения приняты контрагентом',
    //   element: <BlueSquare />,
    // },
    // {
    //   text: 'Согласовано Менеджером на размещение',
    //   element: <GreenCheckmark />,
    // },
    // {
    //   text: 'Вакансия не согласована, но произведены исправления Менеджером',
    //   element: <BlueCross />,
    // },
    // {
    //   text: 'Вакансия была редактирована, изменения сохранены, но была отменена и  вакансия осталась в блоке «на модерации»',
    //   element: <RedCross />,
    // },

    // {
    //   text: 'Вакансия была отредактирована Администратором/Менеджером и отправлена на ознакомление Контрагенту',
    //   element: <GreenSquare />,
    // },
    // {
    //   text: 'Вакансия создана на главной странице или деактивизирована Контрагентом или прекращена по сроку действий',
    //   element: <RedSquare />,
    // },
    // {
    //   text: 'Вакансия создана Менеджером/Администратором',
    //   element: <GreenCircle />,
    // },

    // {
    //   text: 'Вакансия создана Менеджером/Администратором',
    //   element: <OrangeCircle />,
    // },
  };
  const currentVacancyStatus = vacancyTypes?.[type] ? vacancyTypes?.[type] : null;
  return (
    <>
      {currentVacancyStatus ? (
        <>
          <p data-tooltip-id={id} data-tooltip-content={currentVacancyStatus?.text}>
            {currentVacancyStatus?.element}
          </p>
          <Tooltip id={id} className="z-[10000]" render={({ content }) => <div className="flex w-60">{content}</div>} />
        </>
      ) : (
        <div></div>
      )}
    </>
  );
}
